<template>
  <div class="table-member-profile">
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="applyFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row mb-3">
            <div class="col">
              <a-input :placeholder="placeholder" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="membership_number"
                  style="width: 110px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="name"> Name </a-select-option>

                  <a-select-option value="mobile_no">
                    Mobile No
                  </a-select-option>

                  <a-select-option value="email"> Email </a-select-option>

                  <a-select-option value="membership_number">
                    Member ID
                  </a-select-option>
                  <!-- <a-select-option value="card_number">
                    Card Number
                  </a-select-option> -->
                </a-select>
              </a-input>

              <small
                ><i>
                  <small>{{ example }}</small></i
                ></small
              >
            </div>
          </div>
        </form>
        <br />
        <form role="form" @submit.prevent>
          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter By Registration Status
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.registration_status"
                  show-search
                  mode="multiple"
                  optionFilterProp="children"
                >
                  <a-select-option value="INCOMPLETE">
                    Incomplete
                  </a-select-option>
                  <a-select-option value="COMPLETE"> Complete </a-select-option>
                  <a-select-option value="UNREGISTERED">
                    Unregistered
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter By Membership Program
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.membership_program_id"
                  show-search
                  optionFilterProp="children"
                  @change="
                    () => {
                      onChangeMembershipProgram();
                    }
                  "
                >
                  <a-select-option :value="null"> All </a-select-option>
                  <a-select-option
                    v-for="membershipProgram in options.membershipPrograms"
                    :key="membershipProgram.id"
                    :value="membershipProgram.id"
                    :label="membershipProgram.name"
                  >
                    {{ membershipProgram.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter By Membership Level
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.membership_level_id"
                  show-search
                  optionFilterProp="children"
                >
                  <a-select-option :value="null"> All </a-select-option>
                  <a-select-option
                    v-for="membershipLevel in options.membershipLevels"
                    :key="membershipLevel.id"
                    :value="membershipLevel.id"
                    :label="membershipLevel.name"
                  >
                    {{ membershipLevel.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter By Member Status
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.member_status_id"
                  show-search
                  mode="multiple"
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="membershipLevel in options.memberStatuses"
                    :key="membershipLevel.id"
                    :value="membershipLevel.id"
                    :label="membershipLevel.name"
                  >
                    {{ membershipLevel.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="applyFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
          style="height: 50vh"
        >
          <template #headerButtons>
            <base-dropdown class="nav-link pr-0 float-right" position="right">
              <div class="media align-items-center" slot="title">
                <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
              </div>
              <template>
                <div class="dropdown-header noti-title">
                  <h6 class="text-overflow m-0">ACTIONS</h6>
                </div>

                <div class="dropdown-item">
                  <downloadexcel
                    :fetch="fetchJsonData"
                    :escapeCsv="false"
                    :fields="excelExportOpts.jsonFields"
                    :type="excelExportOpts.filetype"
                    :name="excelExportOpts.filename"
                    :before-generate="beforeGenerateData"
                  >
                    <i class="fa fa-download"></i> <span>Export to excel</span>
                  </downloadexcel>
                </div>
              </template>
            </base-dropdown>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              v-if="selectedActions.includes('Add')"
              @click="openDrawer()"
              >+ Add Member
            </base-button>

            <base-button
              id="quick-registration"
              class="float-right ml-1"
              type="danger"
              size="sm"
              v-if="selectedActions.includes('Quick Add')"
              @click="openQuickRegistration()"
              >+ Quick Registration
            </base-button>

            <base-button
              id="bulk-member-tag"
              class="float-right ml-1"
              type="info"
              size="sm"
              v-if="selectedActions.includes('Quick Add')"
              @click="openBulkDrawer()"
              >Member Tag Bulk
            </base-button>
          </template>

          <template #formDrawer>
            <a-drawer
              :maskClosable="false"
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              :key="formKey"
              @close="closeDrawer"
            >
              <MemberProfileForm
                :viewMode="viewMode"
                :memberData="memberData"
                :drawerVisible="drawer.visible"
                @closeDrawer="closeDrawer"
                :quickRegistration="quickRegistration"
                :currentSiteId="currentSiteId"
                :dataPrivacyFilePath="dataPrivacyFilePath"
              />
            </a-drawer>

            <a-drawer
              :width="interactionDrawer.width"
              :placement="interactionDrawer.placement"
              :visible="interactionDrawer.visible"
              @close="closeInteractionDrawer"
            >
              <InteractionLogForm
                :memberData="memberData"
                @closeDrawer="closeInteractionDrawer"
              />
            </a-drawer>

            <a-drawer
              :width="bulkDrawer.width"
              :placement="bulkDrawer.placement"
              :visible="bulkDrawer.visible"
              @close="closeBulkDrawer"
            >
              <BulkMemberTagForm
                :memberTagData="memberTagData"
                @closeDrawer="closeBulkDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <base-dropdown class="nav-link pr-0" position="left">
              <div class="media align-items-center" slot="title">
                <i class="fa fa-ellipsis-v ml-2 btn-sm"></i>
              </div>
              <template>
                <div class="dropdown-header noti-title">
                  <h6 class="text-overflow m-0">ACTIONS</h6>
                </div>

                <div
                  class="dropdown-item"
                  v-if="selectedActions.includes('View Trx Hist.')"
                  @click="memberTransactionHistory(tableProps.rowData)"
                >
                  <i class="fa fa-list-ul"></i>
                  Transaction History
                </div>

                <div
                  class="dropdown-item"
                  v-if="selectedActions.includes('View')"
                  @click="openDrawer(tableProps.rowData, 'view')"
                >
                  <i class="fa fa-address-book"></i> View
                </div>

                <div
                  id="edit"
                  class="dropdown-item"
                  v-if="selectedActions.includes('Edit')"
                  @click="openDrawer(tableProps.rowData, 'edit')"
                >
                  <i class="fa fa-user"></i> Edit
                </div>

                <div
                  id="view"
                  v-if="selectedActions.includes('Item Redemption')"
                  class="dropdown-item"
                  @click="itemRedemption(tableProps.rowData)"
                >
                  <i class="fa fa-shopping-basket"></i>
                  Item Redemption
                </div>

                <div
                  v-if="
                    tableProps.rowData.registration_status != 'UNREGISTERED' &&
                    selectedActions.includes('Interactions')
                  "
                  class="dropdown-item"
                  @click="openInteractionDrawer(tableProps.rowData)"
                >
                  <i class="fa fa-comments"></i> Interactions
                </div>

                <a-popconfirm
                  title="You are about to delete this record?"
                  v-if="selectedActions.includes('Delete')"
                  @confirm="deleteRow(tableProps.rowData)"
                  okText="Delete"
                  cancelText="Cancel"
                >
                  <div class="dropdown-item">
                    <i class="fa fa-trash"></i> Delete
                  </div>
                </a-popconfirm>
              </template>
            </base-dropdown>
          </template>

          <template #customComponent="{ tableProps }">
            <span>
              {{ tableProps.rowData.membership_number }}
            </span>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import MemberProfileForm from './MemberProfileForm.vue';
import InteractionLogForm from '../MemberManagement/InteractionLogForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '../../controllers/secureStorage';
import BulkMemberTagForm from './BulkMemberTagForm.vue';
import { mapGetters } from 'vuex';
import '@/assets/css/custom.css';
import moment from 'moment';

import downloadexcel from 'vue-json-excel';

import { maskString } from '../../helpers/stringHelper.js';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    MemberProfileForm,
    InteractionLogForm,
    BulkMemberTagForm,
    downloadexcel
  },
  data() {
    return {
      formKey: 0,
      currentSiteId: null,
      dataPrivacyFilePath: null,
      hasCardSellingModule: false,
      // selectedActions: [],
      gradientType: 'gradient-blue',
      memberData: null,
      searchType: 'membership_number',
      search: null,
      placeholder: 'Member ID',
      example: 'Member ID (e.g. PRIMER-12345567)',
      quickRegistration: false,
      memberTagData: null,
      drawer: {
        visible: false,
        width: 0,
        placement: 'right'
      },
      bulkDrawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      interactionDrawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Member Profiles',
        apiUrl:
          '/api/v1/clp_members?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [
          { name: 'actions', title: '' },
          // { name: 'membership_number', title: 'Member ID' },
          {
            name: 'registeredSite.name',
            title: 'Registered Branch',
            formatter: (val) => val
          },
          { name: 'custom-slot', title: 'Member ID' },
          {
            name: 'first_name',
            title: 'First Name',
            formatter: (val) => maskString(val)
          },
          {
            name: 'last_name',
            title: 'Last Name',
            formatter: (val) => maskString(val)
          },
          {
            name: 'mobile_no',
            title: 'Mobile Number',
            formatter: (val) => maskString(val)
          },
          {
            name: 'registration_status',
            title: 'Regis. Status',
            formatter: (val) => val
          },
          {
            name: 'memberStatus.name',
            title: 'Member Status',
            formatter: (val) => val
          },
          // 'status',
          {
            name: 'member_started_at',
            title: 'Registration Date',
            formatter(value) {
              if (!value) return '-';
              const date = moment(value);
              return date.isValid() ? date.format('MMM/DD/YYYY') : '';
            }
          },
          {
            name: 'is_migrated',
            title: 'Migrated',
            formatter(value) {
              return value === 1 ? 'Yes' : 'No';
            }
          }
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        filters: {
          registration_status: [],
          first_name: null,
          last_name: null,
          filter: false,
          member_status_id: [],
          membership_level_id: null,
          membership_program_id: null,
          mobile_no: null,
          membership_number: null,
          email: null,
          export_data: false
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      },

      excelExportOpts: {
        jsonFields: {
          'Registered Branch': 'registeredSite.name',
          'Member ID': 'membership_number',
          'First Name': 'first_name',
          'Last Name': 'last_name',
          'Mobile Number': 'mobile_no',
          'Registration Status': 'registration_status',
          'Member Status': 'memberStatus.name',
          'Registration Date': {
            field: 'member_started_at',
            callback: (value) => {
              if (!value) return '-';
              const date = moment(value);
              return date.isValid() ? date.format('MMM/DD/YYYY') : '';
            }
          },
          Migrated: {
            field: 'is_migrated',
            callback: (value) => {
              return value === 1 ? 'Yes' : 'No';
            }
          }
        },
        filetype: 'xls',
        filename: 'member-transaction-list.xls'
      },

      options: {
        memberStatuses: [],
        membershipLevels: [],
        membershipPrograms: []
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null, target = null) {
      this.viewMode = target == 'view' ? true : false;
      this.memberData = rowData;
      this.formKey++;
      this.drawer.visible = true;
    },

    openInteractionDrawer(rowData = null) {
      this.memberData = rowData;
      this.interactionDrawer.visible = true;
    },

    openQuickRegistration() {
      this.quickRegistration = true;
      this.drawer.visible = true;
    },

    openBulkDrawer(rowData = null) {
      console.log('INZ', rowData);
      // this.memberTagData = rowData;
      this.bulkDrawer.visible = true;
    },

    closeBulkDrawer() {
      this.bulkDrawer.visible = false;
      this.memberTagData = null;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.memberData = null;
      this.formKey++;
      this.quickRegistration = false;
    },

    closeInteractionDrawer() {
      this.interactionDrawer.visible = false;
      this.memberData = null;
    },

    memberTransactionHistory(rowData) {
      this.$store.dispatch('setCurrentMember', rowData);
      this.$router.push('/admin/member-transactions');
    },

    itemRedemption(rowData) {
      this.$store.dispatch('setCurrentMember', rowData);
      this.$router.push('/admin/item-redemptions');
    },
    onChangeMembershipProgram() {
      this.getMembershipLevels(this.table.filters.membership_program_id);
      this.getMemberStatuses(this.table.filters.membership_program_id);
    },

    applyFilter() {
      if (this.searchType == 'name' && this.search) {
        const search = this.search.split('/');
        this.table.filters[this.searchType] = null;
        typeof search[0] != 'undefined'
          ? (this.table.filters['first_name'] = search[0].trim())
          : '';
        typeof search[1] != 'undefined'
          ? (this.table.filters['last_name'] = search[1].trim())
          : '';
      }
      if (
        this.table.filters['email'] == null &&
        this.table.filters['first_name'] == null &&
        this.table.filters['last_name'] == null &&
        this.table.filters['member_status_id'].length == 0 &&
        this.table.filters['membership_level_id'] == null &&
        this.table.filters['membership_number'] == null &&
        this.table.filters['membership_program_id'] == null &&
        this.table.filters['mobile_no'] == null &&
        // this.table.filters['card_number'] == null &&
        this.table.filters['registration_status'].length == 0
      ) {
        this.table.filters.filter = false;
      } else {
        this.table.filters.filter = true;
      }
      const state = {
        filters: { ...this.table.filters },
        fromBackButton: false
      };
      this.$store.dispatch('setMemberProfileFilter', state);
      this.setFilter();
    },
    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async getMemberStatuses(membershipProgramId, selectedStatus = []) {
      if (membershipProgramId == null) {
        this.table.filters.member_status_id = [];
        this.options.memberStatuses = [];
      } else {
        const data = await HTTPRequest.getRequest(
          `/api/v1/clp_membership_programs/${membershipProgramId}/member_statuses`
        );
        this.table.filters.member_status_id = selectedStatus;
        this.options.memberStatuses = data.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : b.name.toLowerCase() > a.name.toLowerCase()
            ? -1
            : 0
        );
      }
    },

    async getMembershipLevels(membershipProgramId, selectedLevel = null) {
      if (membershipProgramId == null) {
        this.table.filters.membership_level_id = null;
        this.options.membershipLevels = [];
      } else {
        const data = await HTTPRequest.getRequest(
          `/api/v1/clp_membership_programs/${membershipProgramId}/membership_levels`
        );
        this.table.filters.membership_level_id = selectedLevel;
        this.options.membershipLevels = data.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : b.name.toLowerCase() > a.name.toLowerCase()
            ? -1
            : 0
        );
      }
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    searchTypeOnChange() {
      this.table.filters = {
        registration_status: [],
        first_name: null,
        last_name: null,
        name: null,
        member_status_id: [],
        membership_level_id: null,
        membership_program_id: null,
        mobile_no: null,
        membership_number: null
      };
      let search = [];

      switch (this.searchType) {
        case 'name':
          this.placeholder = 'First Name / Last Name';
          this.example = 'First Name / Last Name (e.g. John / Doe)';
          if (this.search) {
            search = this.search.split('/');
            typeof search[0] !== 'undefined'
              ? (this.table.filters['first_name'] = search[0])
              : '';
            typeof search[1] !== 'undefined'
              ? (this.table.filters['last_name'] = search[1])
              : '';
          }
          break;
        case 'mobile_no':
          this.placeholder = 'Mobile Number';
          this.example = 'Mobile Number (e.g. +639123456789)';
          break;
        case 'email':
          this.placeholder = 'Email';
          this.example = 'Email (e.g. johndoe@gmail.com)';
          break;
        case 'membership_number':
          this.placeholder = 'Member ID';
          this.example = 'Member ID (e.g. 123456)';
          break;
        // case 'card_number':
        //   this.placeholder = 'Card Number';
        //   this.example = 'Card Number (e.g. 100000234567)';
        //   break;
      }
      if (this.searchType != 'name') {
        this.table.filters[this.searchType] = this.search;
      }
    },

    async deleteRow(rowData) {
      const memberId = rowData.id;

      const response = await HTTPRequest.deleteRequest(
        `/api/v1/clp_members/${memberId}`
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    },

    async fetchJsonData() {
      this.table.filters.export_data = true;
      const _params = this.table.filters;
      const _apiUrl = this.table.apiUrl;

      let arr = [];
      for (let key in _params) {
        if (_params[key] !== null) {
          arr.push(key + '=' + _params[key]);
        }
      }
      const queryString = arr.join('&');

      try {
        console.log('Fetching data:', _apiUrl + '?' + queryString);
        const response = await HTTPRequest.getRequest(
          _apiUrl + '?' + queryString
        );
        console.log('Data fetched successfully:', response);

        return response;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.table.filters.export_data = false;
      }
    },
    beforeGenerateData() {
      this.$message.loading('Generating data', 1);
    }
  },

  watch: {
    search(val) {
      if (val == '') {
        this.search = null;
        this.table.filters['first_name'] = null;
        this.table.filters['last_name'] = null;
      } else {
        this.table.filters.filter = true; //added this to force search to true I don't know why it is not working on the staging
      }

      this.table.filters[this.searchType] = val;
    },

    'table.filters.membership_program_id': function (val) {
      this.getMemberStatuses(val);
      this.getMembershipLevels(val);
    },
    '$store.getters.getDataPrivacyPolicy': function (obj) {
      this.dataPrivacyFilePath =
        obj?.file_path != null
          ? process.env.VUE_APP_API_BASE_URL + '/' + obj.file_path
          : null;
    }
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'MemberProfile');
    this.getMembershipPrograms();

    // console.log('getCardSellingFeature: ', this.getCardSellingFeature());

    // Set the drawer width to 4/10 of the screen
    let windowWidth = window.innerWidth;
    this.drawer.width = (windowWidth / 10) * 7;

    this.currentSiteId = secureStorage.getItem('currentSiteId');
  },

  async mounted() {
    let data = this.$store.getters.getMemberProfileFilter;
    if (data && data.fromBackButton) {
      if (data.filters.membership_program_id) {
        await this.getMembershipLevels(
          data.filters.membership_program_id,
          data.filters.membership_level_id
        );
        await this.getMemberStatuses(
          data.filters.membership_program_id,
          data.filters.member_status_id
        );
      }
      console.log(data.filters);
      this.table.filters.registration_status = data.filters.registration_status;
      this.table.filters.first_name = data.filters.first_name;
      this.table.filters.last_name = data.filters.last_name;
      this.table.filters.membership_program_id =
        data.filters.membership_program_id;
      this.table.filters.mobile_no = data.filters.mobile_no;
      this.table.filters.membership_number = data.filters.membership_number;
      this.table.filters.email = data.filters.email;
      this.table.filters.filter = true;
      if (data.filters.membership_number != null) {
        this.search = data.filters.membership_number;
        this.searchType = 'membership_number';
      }
      if (data.filters.mobile_no != null) {
        this.search = data.filters.mobile_no;
        this.searchType = 'mobile_no';
      }
      if (data.filters.email != null) {
        this.search = data.filters.email;
        this.searchType = 'email';
      }
      // if (data.filters.card_number != null) {
      //   this.search = data.filters.card_number;
      //   this.searchType = 'card_number';
      // }
      if (data.filters.first_name != null || data.filters.last_name != null) {
        let lastName = data.filters.last_name ? data.filters.last_name : '';
        let firstName = data.filters.first_name ? data.filters.first_name : '';
        if (lastName == '') {
          this.search = firstName;
        } else {
          this.search = firstName + '/' + lastName;
        }
        this.searchType = 'name';
      }
      setTimeout(() => {
        this.table.filters.member_status_id = data.filters.member_status_id;
        this.table.filters.membership_level_id =
          data.filters.membership_level_id;
        this.setFilter();
      }, 1000);
    }
  }
};
</script>

<style scoped></style>
